import { render, staticRenderFns } from "./Training-ls.vue?vue&type=template&id=2b06e69f&scoped=true&"
import script from "./Training-ls.vue?vue&type=script&lang=js&"
export * from "./Training-ls.vue?vue&type=script&lang=js&"
import style0 from "./Training-ls.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Training-ls.vue?vue&type=style&index=1&id=2b06e69f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b06e69f",
  null
  
)

export default component.exports